module.exports = __webpack_public_path__ + "img/collection-engagementRingsRingsets.89802de.jpg";